module.exports = __webpack_public_path__ + "img/Compliance Automation.3728f66a.svg";